import { useMutation } from "react-query";
import { Put } from "../utils/api";
import { useAuth0 } from "@auth0/auth0-react";
import { useQueryClient } from "react-query";
import { Address } from "../../types/api/Address";
import { User } from "../../types/api/User";

export interface PutAddressBody {
  organization: {
    id: string;
  };
  address: Address;
  is_default_shipping: boolean;
  is_default_billing: boolean;
}

export default (organizationId: string) => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();
  return useMutation<User, null, PutAddressBody>(
    async (body: PutAddressBody) =>
      Put(`/api/address/organization`, await getAccessTokenSilently(), body),
    {
      onSuccess: (res) => {
        queryClient.invalidateQueries([`addresses-${organizationId}`]);
      },
    }
  );
};
